const navPrimary = (brkpt) => {
  const cls = `nav_primary`,
    tl = new TimelineLite(),
    dur = 0.35;

  new Component({
    component: document.querySelectorAll(`.${cls}`),
    callback: (component) => {
      const pages = component.querySelector(`.${cls}-pages`);
      const account = component.querySelector(`.${cls}-account`);

      let mobileContainer,
        activeAccordion = null;

      // remove nav flash on load
      component.classList.remove('onload');

      const toggleHref = (target) => {
        target = target.querySelector(`a`);
        const dataSrc = target.getAttribute('data-src');
        if (target.nextElementSibling && dataSrc) {
          if (target.href) {
            target.removeAttribute('href');
          } else {
            target.href = dataSrc;
          }
        }
      };

      const markup = () => {

        const mobile = new Responsive({
          breakpoint: brkpt,
          direction: `down`,
          callback: () => {

            mobileContainer = new Element({
              type: `div`,
              classes: `${cls}-mobile_nav`,
              append: {
                parent: component
              }
            });

            mobileContainer.appendChild(pages);
            mobileContainer.appendChild(account);

          },
        });

        const desktop = new Responsive({
          breakpoint: brkpt,
          direction: `up`,
          callback: () => {
            var desktopNav = component.querySelector('#desktop_nav');

            if (mobileContainer) {
              desktopNav.appendChild(pages);
              desktopNav.appendChild(account);
              mobileContainer.parentNode.removeChild(mobileContainer);
            }

          },
        });
      }

      const accordion = () => {
        let subNavHeight = [];

        const subNav = new Component({
          component: component.querySelectorAll(`.${cls}-pages > li`),
          callback: (li, allLi, allLiIndex) => {
            const subnav = li.querySelector(`.${cls}-subnav`);

            const storeHeight = () => {
              if (li.querySelector(`.${cls}-subnav`)) {
                subNavHeight.push(li.querySelector(`.${cls}-subnav_wrapper`).offsetHeight);
              } else {
                subNavHeight.push(null);
              }
            }

            function accordionToggle() {
              const slug = this.getAttribute('data-parent');

              if (activeAccordion == slug) {
                accordionClose();
                activeAccordion = null;
              } else {
                accordionOpen(slug);
              }
            };

            const accordionClose = () => {
              const tl1 = new TimelineLite();
              const activeSubmenu = component.querySelector(`[data-subnav=${activeAccordion}] .${cls}-subnav_wrapper`);

              tl1.to(activeSubmenu, dur, {
                height: 0,
                ease: Power2.easeOut,
              }, 'close');

              activeSubmenu.parentElement.classList.remove('open');
            };

            function accordionOpen(slug) {
              const tl1 = new TimelineLite();

              if (activeAccordion != null) {
                accordionClose();
              }

              activeAccordion = slug;
              const activeSubmenu = component.querySelector(`[data-subnav=${activeAccordion}] .${cls}-subnav_wrapper`);

              tl1.to(activeSubmenu, dur, {
                height: subNavHeight[allLiIndex],
                ease: Power2.easeOut,
              }, 'open');

              activeSubmenu.parentElement.classList.add('open');
            };

            const mobile = new Responsive({
              breakpoint: brkpt,
              direction: 'down',
              callback: () => {

                storeHeight();
                toggleHref(li);

                if (subnav) {
                  li.addEventListener('click', accordionToggle);
                  subnav.querySelector(`.${cls}-subnav_wrapper`).style.height = `0px`;

                  // If it's the section we're already on when we load, immediately open it
                  if (li.querySelector('.open')) {
                    accordionToggle.apply(li);
                  }
                }

              },
            });

            const desktop = new Responsive({
              breakpoint: brkpt,
              direction: 'up',
              callback: (onload) => {
                const allSubnav = component.querySelectorAll(`[data-subnav]`);

                if (!onload) {
                  toggleHref(li);
                }

                if (subnav) {
                  li.removeEventListener('click', accordionToggle);
                }

                for (let i = 0; i < allSubnav.length; i++) {
                  const element = allSubnav[i];
                  if (element.querySelector(`.${cls}-subnav_wrapper`).hasAttribute('style')) {
                    element.querySelector(`.${cls}-subnav_wrapper`).removeAttribute('style');
                  }
                  if (element.parentElement.classList.contains('open')) {
                    element.parentElement.classList.remove('open');
                  }
                }
                activeAccordion = null;

              },
            });

          },
        })
      };

      const navToggle = () => {
        const button = component.querySelector(`.${cls}-toggle button`),
          tl1 = new TimelineLite();

          let isOpen = false,
            navHeight = 0;

        function toggle() {
          const windowHeight = window.innerHeight,
            paddingTop = window.getComputedStyle(component, null).getPropertyValue('padding-top').split('px')[0],
            paddingBottom = window.getComputedStyle(component, null).getPropertyValue('padding-bottom').split('px')[0],
            openHeight = windowHeight - paddingTop - paddingBottom;

          let mobileNav = component.querySelector(`.${cls}-mobile_nav`);

          if (!isOpen) {

            tl1.to(mobileNav, dur, {
              height: openHeight,
              ease: Power2.easeOut,
            });

            if (!body.classList.contains('nav_is_open')) {
              body.classList.add('nav_is_open');
            }

            if (!this.parentElement.classList.contains('open')) {
              this.parentElement.classList.add('open');
            }

            isOpen = true;

          } else {

            tl1.to(mobileNav, dur, {
              height: 0,
              ease: Power2.easeOut,
            });

            if (body.classList.contains('nav_is_open')) {
              body.classList.remove('nav_is_open');
            }

            if (this.parentElement.classList.contains('open')) {
              this.parentElement.classList.remove('open');
            }

            isOpen = false;

          }
        };

        const mobile = new Responsive({
          breakpoint: brkpt,
          direction: 'down',
          callback: (onload) => {
            button.addEventListener('click', toggle);
            component.querySelector(`.${cls}-mobile_nav`).style.height = `0px`;

            // For mobile nav, open the section for the currently selected page
            const currentPage = component.querySelector('.nav_primary--current_page');

            if (currentPage) {
              const parentSubNav = currentPage.closest('.nav_primary-subnav');
              parentSubNav.classList.add('open');
            }
          },
        });

        const desktop = new Responsive({
          breakpoint: brkpt,
          direction: 'up',
          callback: () => {
            let toggle = component.querySelector(`.${cls}-toggle`);
            isOpen = false;
            if (body.classList.contains('nav_is_open')) {
              body.classList.remove('nav_is_open');
            }
            if (toggle.classList.contains('open')) {
              toggle.classList.remove('open');
            }
          },
        });
      };

      markup();
      navToggle();
      accordion();
    },
  });
};

navPrimary(breakpoint.lg);
